module.exports = __webpack_public_path__ + "img/sustain.d06c322e.jpg";